import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const ControlMicrophone = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
    strokeAsPrimary: true,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 12 17'
    >
      <path
        fill={primaryColorToUse}
        d='M5.904 10.207c1.416 0 2.56-1.14 2.56-2.551V2.552A2.55 2.55 0 0 0 5.904 0a2.55 2.55 0 0 0-2.559 2.552v5.104a2.55 2.55 0 0 0 2.56 2.551m5.042-2.551a.85.85 0 0 0-.836.723 4.276 4.276 0 0 1-4.206 3.53 4.276 4.276 0 0 1-4.206-3.53.85.85 0 0 0-.836-.723c-.52 0-.93.459-.853.97a5.96 5.96 0 0 0 5.042 4.916v1.769a.854.854 0 0 0 1.706 0v-1.77a5.97 5.97 0 0 0 3.328-1.635 5.94 5.94 0 0 0 1.714-3.28c.086-.511-.332-.97-.853-.97'
      />
    </svg>
  );
};
